import Jsbridge from "@/jsbridge";
import nativeStorage from "@/utils/nativeStorage/native_storage";
import { urlToFilesName } from "./files_helpers";
import { downloadFiles } from "./download_files";
import { store } from "@/main";
import * as setting_types from "@/store/constants/setting_types";
import VideoPathCache from "./videoPathCache";
import { isIos } from "@/utils/lodash";

const CACHE_VIDEO_DIRECTORY_NAME = "video_files"; // 存到cache的视频目录名
const VIDEO_BUNDLE_NAME = "HLVideo"; // 默认视频类型的bundle name
const VIDEO_SAVE_INDEX_DB_KEY = "VIDEO_SAVE_INDEX_DB_KEY"; // 存储的key值

interface VideoInterface {
  name: string;
  release: number;
  path: string;
}

interface VideoNewInterface {
  name: string;
  release: number;
  content_url: string;
}
interface VideoParamsInterface {
  name: string;
  url: string;
}

/**
 * GetLocalVideos
 */
export const getLocalVideos = async () => {
  try {
    const dbSave = await nativeStorage.get(VIDEO_SAVE_INDEX_DB_KEY);
    if (dbSave) {
      return dbSave;
    } else {
      // empty of db:
      const bundleVideos: VideoInterface[] = await getBundleVideos();
      // save to db
      updateLocalVideosList(bundleVideos);
      return bundleVideos;
    }
  } catch (error) {
    return [];
  }
};

/**
 * 获取需要的本地视频,
 * @param param
 * {
 *  name:string,
 *  url:string,
 * }
 */
export const getTheOneVideo = async (param: VideoParamsInterface) => {
  try {
    const vedioList: any = await getLocalVideos();
    const findLocalVedio = vedioList.find((item: any) => {
      return item.name === param.name;
    });
    return findLocalVedio ? findLocalVedio.path : param.url;
  } catch (error) {
    return param.url;
  }
};

/**
 * Save to db
 * @param arr
 */
export const updateLocalVideosList = async (arr: VideoInterface[]) => {
  console.log("updateLocalVideosList:", arr);
  await nativeStorage.set(VIDEO_SAVE_INDEX_DB_KEY, arr);
};

/**
 * 更新本地的单个的video
 * @param param0
 */
export const upateLocalVideo = async ({
  name,
  release,
  path
}: VideoInterface) => {
  try {
    const upadteVideo = {
      name,
      release,
      path
    };
    const localVideoList: any = await getLocalVideos();
    const findIndex = localVideoList.findIndex((localVideo: VideoInterface) => {
      return localVideo.name === name;
    });

    if (findIndex > -1) {
      localVideoList.splice(findIndex, 1, upadteVideo);
    } else {
      localVideoList.push(upadteVideo);
    }
    updateLocalVideosList(localVideoList);
  } catch (error) {
    //
  }
};

export const downloadVideo = async ({
  name,
  release,
  content_url
}: VideoNewInterface) => {
  try {
    const download_result = await downloadFiles(
      content_url,
      name,
      CACHE_VIDEO_DIRECTORY_NAME
    );
    // 返回path:
    upateLocalVideo({
      name,
      release,
      path: download_result
    });
  } catch (error) {
    //
  }
};

export const initLocalVideos = () => {
  try {
    const { local_files } = store.getters[setting_types.GETTER_CLIENT_SETTINGS];
    local_files && checkUpdateLocalVideos(local_files);
  } catch (error) {
    //
  }
};

/**
 * Update Local video list
 * @param updateList
 */
export const checkUpdateLocalVideos = async (
  updateList: VideoNewInterface[]
) => {
  try {
    const localVideoList: any = await getLocalVideos();

    for (const upadteVideo of updateList) {
      const matchVideo = localVideoList.find((oldVideo: any) => {
        return oldVideo.name === upadteVideo.name;
      });

      if (matchVideo) {
        if (upadteVideo.release > matchVideo.release) {
          console.log("downloadVideo1");
          downloadVideo(upadteVideo);
        }
      } else {
        console.log("downloadVideo2");
        downloadVideo(upadteVideo);
      }

      // name to match need to download files:
    }
  } catch (error) {
    //
  }
};

/**
 * GetBundleVideos from bundle default
 */
export const getBundleVideos = async () => {
  try {
    const localPaths: any = await Jsbridge.localPathGet(false, [
      VIDEO_BUNDLE_NAME
    ]);
    const pathArr = localPaths[VIDEO_BUNDLE_NAME];
    const resolveVideos: VideoInterface[] = pathArr.map((path: string) => {
      return {
        release: 0,
        path,
        name: urlToFilesName(path)
      };
    });
    console.log("resolveVideos:", resolveVideos);
    return resolveVideos;
  } catch (error) {
    return [];
  }
};

export const handleLocalVideo = async (content_url: string, name: string) => {
  try {
    if (isIos()) {
      if (VideoPathCache.get()) {
        return VideoPathCache.get();
      } else {
        const download_result = await downloadFiles(
          content_url,
          name,
          CACHE_VIDEO_DIRECTORY_NAME
        );
        console.log("localPaths", download_result);
        VideoPathCache.setCache(download_result);
        return download_result;
      }
    } else {
      return content_url;
    }
  } catch (e) {
    return content_url;
  }
}
